import {useSelector} from 'react-redux';

export const useProject = () => {
 const projectID = useSelector(({app}) => app.projectUID);
 const token = useSelector(({app})=>app.token);
 return {
   projectID,token
 }
}
